// import { Leaderboard } from '@/components/templates/Leaderboard/Leaderboard'
import { useRouter } from 'next/router'
import { memo, useEffect } from 'react'

const LeaderboardPage = () => {
  const router = useRouter()

  if (!router.isReady) {
    return null
  }

  useEffect(() => {
    router.replace('/')
  }, [])
  return null
  // return <Leaderboard />
}

export default memo(LeaderboardPage)
